module.exports = __webpack_public_path__ + "img/case_sensitive_hover.6080e65f.svg";